export default __webpack_public_path__ + "static/media/hrk.11bc5d01.png";